import { render } from "./VendorTable.vue?vue&type=template&id=27d09d0c&scoped=true"
import script from "./VendorTable.vue?vue&type=script&lang=js"
export * from "./VendorTable.vue?vue&type=script&lang=js"

import "./VendorTable.vue?vue&type=style&index=0&id=27d09d0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d09d0c"]])

export default __exports__